import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { Permission } from '@qtek/shared/models';

interface PermissionsState {
  permissions: Map<string, Permission>;
}

const initialState: PermissionsState = {
  permissions: new Map<string, Permission>(),
};

export const PermissionsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(store => ({
    setPermissions(permissions: Permission[]): void {
      patchState(store, {
        permissions: new Map(permissions.map(p => [p.id, p])),
      });
    },
  }))
);
